import clsx from 'clsx';
import PropTypes from 'prop-types';
import { memo, useState } from 'react';
import { useAnalytics } from 'use-analytics';
import TabPanel from '../../../TabPanel';
import PhotosDetails from '../../../ImageGallery';
import PricingDetail from './PricingDetail';
import MarkdownToHtml from '../../../MarkdownToHtml';

const CustomInventoryDetails = ({ tripId, itinerary }) => {
  const selectedTabClasses = 'text-theme border-b-2 border-theme';
  const [selectedTab, setSelectedTab] = useState(itinerary.detailTabs[0].id);
  const { track } = useAnalytics();

  const handleTabChange = (index) => {
    setSelectedTab(index);
    track('CustomInventoryDetails.handleTabChange', {
      index,
    });
  };

  return (
    <div>
      <div className="grid grid-flow-col auto-cols-max gap-5 border-b-2 mb-5 mt-8 overflow-x-auto text-sm md:text-base text-center">
        {itinerary.detailTabs.map((t) => (
          <a
            key={t.id}
            onClick={() => {
              handleTabChange(t.id);
            }}
            onKeyDown={() => {}}
            role="button"
            tabIndex="-4"
            className={clsx(
              selectedTab === t.id && selectedTabClasses,
              'py-4 lg:w-24 focus:outline-none block w-full',
            )}
          >
            {t.name}
          </a>
        ))}
        <a
          onClick={() => {
            handleTabChange(0);
          }}
          onKeyDown={() => {}}
          role="button"
          tabIndex="-3"
          className={clsx(
            selectedTab === 0 && selectedTabClasses,
            'py-4 lg:w-24 focus:outline-none block w-full',
          )}
        >
          Photo
        </a>
        <a
          onClick={() => {
            handleTabChange(-1);
          }}
          onKeyDown={() => {}}
          role="button"
          tabIndex="-2"
          className={clsx(
            selectedTab === -1 && selectedTabClasses,
            'py-4 lg:w-24 focus:outline-none block w-full',
          )}
        >
          Pricing
        </a>
      </div>
      <>
        {itinerary.detailTabs.map((t) => (
          <TabPanel value={selectedTab} index={t.id} key={t.id}>
            <MarkdownToHtml content={t.content} />
          </TabPanel>
        ))}
        <TabPanel value={selectedTab} index={0}>
          <PhotosDetails images={itinerary.photos} />
        </TabPanel>
        <TabPanel value={selectedTab} index={-1}>
          <PricingDetail itinerary={itinerary} tripId={tripId} />
        </TabPanel>
      </>
    </div>
  );
};

CustomInventoryDetails.propTypes = {
  tripId: PropTypes.string.isRequired,
  itinerary: PropTypes.shape().isRequired,
};

export default memo(CustomInventoryDetails);
